import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const getForms = async () => (await request.getInstance()).get(API_ROUTES.form.getAllForms);
